export const iconStyle = { width: '2.5rem', height: '2.5rem', color: '#f9f9f9' };
export const timerIconStyle = { width: '5rem', height: '5rem', color: '#f9f9f9' };
